import React from "react";
import "./Skill.css";
// import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { v4 as uuidv4 } from "uuid";
import Card from "./Card";
import Carousel from "./Carousel";
import NodeJS from "../../img/Skills/NodeJS.png";
import ExpressJS from "../../img/Skills/ExpressJS.png";
import Firebase from "../../img/Skills/Firebase.png";
import GitHub from "../../img/Skills/GitHub.jpg";
import HTMLCSSJS from "../../img/Skills/HTMLCSSJS.webp";
import ReactRedux from "../../img/Skills/ReactRedux.jpeg";
import MongoDB from "../../img/Skills/MongoDB.png";

function Skill() {
  let cards = [
    {
      key: uuidv4(),
      content: <Card image={ReactRedux} title="React & Redux" />,
    },
    {
      key: uuidv4(),
      content: <Card image={NodeJS} title="Node JS" />,
    },
    {
      key: uuidv4(),
      content: <Card image={MongoDB} title="Mongo DB" />,
    },
    {
      key: uuidv4(),
      content: <Card image={HTMLCSSJS} title="HTML CSS JS" />,
    },
    {
      key: uuidv4(),
      content: <Card image={Firebase} title="Firebase" />,
    },
    {
      key: uuidv4(),
      content: <Card image={GitHub} title="Git & GitHub" />,
    },
    {
      key: uuidv4(),
      content: <Card image={ExpressJS} title="Express JS" />,
    },
  ];

  return (
    <div className="skill" id="skill">
      {/* <h2>Skills</h2> */}
      <div className="skill_top">
        <Carousel
          cards={cards}
          height="500px"
          width="30%"
          margin="0 auto"
          offset={2}
          showArrows={false}
        />
      </div>
    </div>
  );
}

export default Skill;
